import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    dialogWrapper: {
      width: "544px",
      "& button + button": {
        background: theme.palette.text.brand_tertiary,
      },
    },
    modalIcon: {
      display: "flex",
      alignItems: "center",
      borderRadius: "50%",
      maxWidth: "48px",
      width: "100%",
      height: "48px",
      background: "#FEE4E2",
      justifyContent: "center",
      marginRight: "16px",
    },
  };
});
